export default  {
    apiKey: "AIzaSyCh0cBFDonuqlYBXn6eJEDgA2ZE5VboE1o",
    authDomain: "venturexlabs-124c1.firebaseapp.com",
    databaseURL: "https://venturexlabs-124c1.firebaseio.com",
    projectId: "venturexlabs-124c1",
    storageBucket: "venturexlabs-124c1.appspot.com",
    messagingSenderId: "667449972051",
    appId: "1:667449972051:web:50e66bf0c6df92fe537da6",
    measurementId: "G-5476F8C0FR"
  };